


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import SideModal from '@/shared/components/SideModal/SideModal.vue';
import ErrorInfo from './ErrorInfo.vue';

import { ITraceableError } from '@/interfaces/Error';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    ErrorInfo,
    SideModal,
  }
})
export default class ModalError extends Vue {
  @Prop()
  private error: ITraceableError;

  @CheckoutModule.Mutation
  private closeUpsellModal: Function;

  get open(): boolean {
    if (!this.error || this.error.code === 1107) {
      return false;
    }

    if (this.error && this.error.visibility && !!this.error.visibility) {
      this.close();
    }

    return !!this.error.visibility;
  }

  private close() {
    this.closeUpsellModal();
  }
}
